import React, { useEffect, useState } from 'react';
import { TableCell } from '@mui/material';

import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import { KOGTableRow } from '@/main/components/shared/boxGrid/styles';

import { insurerApi } from '@/main/api';
import * as S from './styles';
import * as SP from '../styles';
import { getTranslateByKey } from '@/main/services/utils';

interface IInsurerInfoState {
  id: string;
  name: string;
}
interface IInsurerInfoProps {
  guidBodyshopEdit: string | null;
}

function InsurerInfo({ guidBodyshopEdit }: IInsurerInfoProps) {
  const [dataInsurer, setDataInsurer] = useState<IInsurerInfoState[]>([]);

  useEffect(() => {
    if (guidBodyshopEdit) {
      insurerApi
        .getInsurersBodyshopAgreements({ guidBodyShop: guidBodyshopEdit })
        .then(response => {
          const responseInsurer = response.data.result;
          if (responseInsurer.length > 0) {
            const formattedInsurer = responseInsurer.map(insurer => ({
              id: insurer.guid,
              name: insurer.tradeName
            })) as IInsurerInfoState[];

            setDataInsurer(formattedInsurer);
          }
        });
    }
  }, [guidBodyshopEdit]);

  return (
    <S.Container>
      <SP.HeaderSection>
        <SP.HeaderText>
          {getTranslateByKey('information.insurerCompany')}
        </SP.HeaderText>
      </SP.HeaderSection>

      {dataInsurer.length > 0 && (
        <BoxGrid rowHeaders={[getTranslateByKey('information.insurerCompany')]}>
          {dataInsurer.map(insurer => (
            <KOGTableRow key={insurer.id}>
              <TableCell width="100%">{insurer.name}</TableCell>
            </KOGTableRow>
          ))}
        </BoxGrid>
      )}
    </S.Container>
  );
}

export default InsurerInfo;
